var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCarpet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_46651",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5H0V24.5H24V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_46651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11.25C20 9.85218 20 8.90326 19.7716 8.35195C19.4672 7.61687 18.8831 7.03284 18.1481 6.72836C17.5967 6.5 16.8978 6.5 15.5 6.5C14.4714 6.5 13.4428 6.5 12.4142 6.5C12.2456 6.5 12.1613 6.5 12.0801 6.49559C11.3976 6.45855 10.7482 6.18957 10.2394 5.73317C10.1788 5.67884 10.1192 5.61923 10 5.5C9.88077 5.38077 9.82116 5.32116 9.7606 5.26683C9.25181 4.81043 8.60243 4.54145 7.91994 4.50441C7.83871 4.5 7.7544 4.5 7.58579 4.5C7.32386 4.5 7.06193 4.5 6.8 4.5C5.11984 4.5 4.27976 4.5 3.63803 4.82698C3.07354 5.1146 2.6146 5.57354 2.32698 6.13803C2 6.77976 2 7.61984 2 9.3C2 11.4333 2 13.5667 2 15.7C2 17.3802 2 18.2202 2.32698 18.862C2.6146 19.4265 3.07354 19.8854 3.63803 20.173C4.27976 20.5 5.11984 20.5 6.8 20.5C8.2 20.5 9.6 20.5 11 20.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33772 12.5C6.33772 12.5 3.70053 14.8649 3.32661 16.3829C2.95269 17.9009 2.99963 18.4553 3.32661 19.0309C3.61423 19.5372 4.07317 19.9488 4.63766 20.2067C5.27939 20.5 6.11947 20.5 7.79963 20.5C10.5996 20.5 13.3996 20.5 16.1996 20.5C17.8798 20.5 18.0789 20.5 18.7207 20.2067C19.2852 19.9488 19.7441 19.5372 20.0317 19.0309C20.2007 18.7334 20.3758 17.7957 20.9496 16.3829C21.4857 15.0627 22.4061 13.2814 22.9996 12.5H6.33772Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCarpet);
export default __webpack_public_path__ + "static/media/FileCarpet.3a4fcc45bb886211e3894357d2d93e53.svg";
export { ForwardRef as ReactComponent };